import { createSlice } from "@reduxjs/toolkit";

export const LarvaIndexSlice = createSlice({
    name: 'larvaindex',
    initialState: {
        coChecked: false,
        ncoChecked: false,
        co: [],
        nco: []
    },
    reducers: {
        setCOChecked: (state, action) => {
            state.coChecked = action.payload;
        },
        setNCOChecked: (state, action) => {
            state.ncoChecked = action.payload;
        },
        setCOValue: (state, action) => {
            state.co = action.payload;
        },
        setNCOValue: (state, action) => {
            state.nco = action.payload;
        }
    }
})

export const { setCOValue, setNCOValue,setCOChecked, setNCOChecked } = LarvaIndexSlice.actions;

export const getCOValue = (state) => state.larvaindex.co;
export const getNCOValue = (state) => state.larvaindex.nco;
export const getCOChecked = (state) => state.larvaindex.coChecked;
export const getNCOChecked = (state) => state.larvaindex.ncoChecked;

export default LarvaIndexSlice.reducer;